// removed by extract-text-webpack-plugin
module.exports = {"horizontalCardGrid":"HorizontalCardGrid__horizontalCardGrid__fNoiy","cardsWrapper":"HorizontalCardGrid__cardsWrapper__1Qz2s","dragging":"HorizontalCardGrid__dragging__3PNza"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/HorizontalCardGrid/HorizontalCardGrid.scss
// module id = 1714
// module chunks = 0